function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	for (const el of document.querySelectorAll("._video_toggle")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.currentTarget;
			const video_result = target.closest("._search-video");
			const current_video = video_result.nextElementSibling; // video_result.next('._show_video');
			const current_video_status = current_video.classList.contains("d-none");
			for (const el of document.querySelectorAll("._show_video")) {
				if (!el.classList.contains("d-none")) {
					el.classList.add("d-none");
					const player_id = el.querySelector('div[id^="video-"]').id;
					const player = jwplayer(player_id);
					player.pause();
				}
			}
			if (current_video_status) {
				current_video.classList.remove("d-none");
			}
		});
	}

	// filtri js
	for (const el of document.querySelectorAll("a._search_filters")) {
		el.addEventListener("click", (event) => {
			const target = event.currentTarget;
			target.setAttribute("href", target.dataset.href);
		});
	}
});
